import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { refresh } from '../../../utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'upgrades.activationModal';
const ActivationErrorModal = () => /*#__PURE__*/_jsxs(UIModal, {
  size: "auto",
  use: "conversational",
  width: 500,
  children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
    color: EERIE,
    onClick: refresh
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsxs(UIErrorMessage, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.errorTitle`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.errorMessage`
        })
      })]
    })
  })]
});
export default ActivationErrorModal;